module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Thanks go to Russell Galen, my agent, and James Frenkel, my editor; Kelly Frieders, Kali Hale, Helen Keier, Beth Loubet, Cindi Manning, Susan Pinsonneault, Jennifer Quail, Bob and Roxanne Quinlan, and Sean Summers, my Eagle-Eyes, the sharp-sighted folk who diminish the number of errors I introduce into each manuscript; and Steph Chiesi, Jenn Hussong, Derrick K. Johnson, Erin M. Lopez, and Luray Richmond, for offering facts when they were hard to come by.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1259d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0